export default __webpack_public_path__ + "static/media/search-icon.c463c5d8.svg";